import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

interface ImageViewerDialogProps {
  open: boolean;
  onClose: () => void;
  imageUrl: string;
  eventName?: string;
  currentIndex?: number;
  totalImages?: number;
  onNext?: () => void;
  onPrevious?: () => void;
}

const ImageViewerDialog: React.FC<ImageViewerDialogProps> = ({
  open,
  onClose,
  imageUrl,
  eventName,
  currentIndex,
  totalImages,
  onNext,
  onPrevious,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: '#000',
          minHeight: '80vh',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          color: 'white',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      >
        <Box>
          <Typography variant="h6">{eventName || 'Image Viewer'}</Typography>
          {totalImages && totalImages > 1 && (
            <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              Image {(currentIndex || 0) + 1} of {totalImages}
            </Typography>
          )}
        </Box>
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
          sx={{ color: 'white' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#000',
          position: 'relative',
          padding: 2,
        }}
      >
        {/* Previous Button */}
        {onPrevious && totalImages && totalImages > 1 && (
          <IconButton
            onClick={onPrevious}
            sx={{
              position: 'absolute',
              left: 16,
              color: 'white',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
              },
            }}
          >
            <NavigateBeforeIcon fontSize="large" />
          </IconButton>
        )}

        {/* Image */}
        <Box
          component="img"
          src={imageUrl}
          alt={eventName || 'Event image'}
          sx={{
            maxWidth: '100%',
            maxHeight: '70vh',
            objectFit: 'contain',
            borderRadius: 1,
          }}
        />

        {/* Next Button */}
        {onNext && totalImages && totalImages > 1 && (
          <IconButton
            onClick={onNext}
            sx={{
              position: 'absolute',
              right: 16,
              color: 'white',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
              },
            }}
          >
            <NavigateNextIcon fontSize="large" />
          </IconButton>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImageViewerDialog;
